import { render } from "./LocationCreate.vue?vue&type=template&id=5c67892c&scoped=true"
import script from "./LocationCreate.vue?vue&type=script&lang=js"
export * from "./LocationCreate.vue?vue&type=script&lang=js"

import "./LocationCreate.vue?vue&type=style&index=0&id=5c67892c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c67892c"]])

export default __exports__